import { isBoolean, isEnumValue } from "@/util/utilFunctions";
import { LayerName } from "./../../../geoMap/LayerName";
import { ISideMenuState } from "./ISideMenuState";
import {
  GENERAL_TRAFFIC_LOCTAION_DATA_TYPE_LIST,
  IControlerDate,
  RADIO_DRM_ROAD_TYPE_LIST,
  RADIO_ETC_DATA_TYPE_LIST,
  RADIO_ETC_DAY_TYPE_LIST,
  RADIO_ETC_TIME_TYPE_LIST,
  RADIO_GENERAL_TRAFFIC_TABLE_TYPE_LIST,
  OD_CAR_TYPE_LIST,
  OD_DATA_TYPE_LIST,
  OD_YEAR_LIST,
  OD_TARGET_LIST,
  RADIO_TRAVOS_HISTORY_LIST,
  RADIO_TRAVOS_LIST,
  RADIO_TRAVOS_REALTIME_LIST,
} from "@/components/define/defineType";

/**
 * 設定読み込みファイル作成処理
 */
export const createExportOptionFile = (
  sideMenuState: ISideMenuState,
  executeMapTime: IControlerDate,
  executeAttributeTime: IControlerDate,
  footerInfo: any,
  visibleMapLayer: LayerName
): any => {
  let backgroundMap;
  switch (visibleMapLayer) {
    case LayerName.StdMapTile:
      backgroundMap = 1;
      break;
    case LayerName.PaleMapTile:
      backgroundMap = 2;
      break;
    case LayerName.BlankMapTile:
      backgroundMap = 3;
      break;
    case LayerName.SeamlessphotoMapTile:
      backgroundMap = 4;
      break;
  }
  const accidentHotspotYear: any = {};
  for (const key in sideMenuState.accidentHotspot.year) {
    accidentHotspotYear[key] = sideMenuState.accidentHotspot.year[key].checked;
  }
  const roadKillYear: any = {};
  for (const key in sideMenuState.roadkill.occurrences.year) {
    roadKillYear[key] = sideMenuState.roadkill.occurrences.year[key].checked;
  }

  const jsonData = {
    type: "画面状態",
    地図情報: {
      緯度: footerInfo.latitude,
      経度: footerInfo.longitude,
      Zoomレベル: footerInfo.zoomLevel,
    },
    Travos: sideMenuState.travos.value,
    Travosデータ: {
      過去最新: sideMenuState.travos.type,
      過去データ: {
        データ種別: sideMenuState.travos.history.timeType,
        常時観測データ計測値: {
          "常設トラカン（様式Q-8-2）":
            sideMenuState.travos.history.measured1Hour.q82,
          "CCTVトラカン（様式QA-8-2）":
            sideMenuState.travos.history.measured1Hour.qa82,
        },
        道路種別: {
          一般国道: sideMenuState.travos.history.generalHighway,
          高速道路: sideMenuState.travos.history.expressway,
        },
      },
      最新データ: {
        データ種別: sideMenuState.travos.realTime.timeType,
        "5分値": {
          "常設トラカン様式（Q-8-1）":
            sideMenuState.travos.realTime.value5Minutes.q81,
          "CCTVトラカン（様式QA-8-1）":
            sideMenuState.travos.realTime.value5Minutes.qa81,
        },
        "1時間値": {
          "常設トラカン様式（Q-8-2）":
            sideMenuState.travos.realTime.value1Hour.q82,
          "CCTVトラカン（様式QA-8-2）":
            sideMenuState.travos.realTime.value1Hour.qa82,
        },
        道路種別: {
          一般国道: sideMenuState.travos.realTime.generalHighway,
          高速道路: sideMenuState.travos.realTime.expressway,
        },
      },
    },
    // 一般交通量調査データ: sideMenuState.generalTraffic.value,
    // 一般交通量調査データの情報: {
    //   種別: sideMenuState.generalTraffic.tableType,
    //   箇所別基本表: {
    //     データ種別: sideMenuState.generalTraffic.location.dataType,
    //     道路種別: {
    //       "一般都道府県道・指定市の一般市道":
    //         sideMenuState.generalTraffic.location.roadCategory
    //           .generalPrefectures,
    //       "主要地方道（都道府県道・指定市道）":
    //         sideMenuState.generalTraffic.location.roadCategory.mainLocalRoad,
    //       "一般国道（直轄）":
    //         sideMenuState.generalTraffic.location.roadCategory
    //           .generalHighwayDirectControl,
    //       "一般国道（その他）":
    //         sideMenuState.generalTraffic.location.roadCategory
    //           .generalHighwayOthers,
    //       都市高速道路:
    //         sideMenuState.generalTraffic.location.roadCategory.urbanHighway,
    //       高速自動車国道:
    //         sideMenuState.generalTraffic.location.roadCategory
    //           .expressNationalHighway,
    //     },
    //   },
    //   時間帯別交通量表: {
    //     時間帯: sideMenuState.generalTraffic.time.specificationTime,
    //     道路種別: {
    //       "一般都道府県道・指定市の一般市道":
    //         sideMenuState.generalTraffic.time.roadCategory.generalPrefectures,
    //       "主要地方道（都道府県道・指定市道）":
    //         sideMenuState.generalTraffic.time.roadCategory.mainLocalRoad,
    //       "一般国道（直轄）":
    //         sideMenuState.generalTraffic.time.roadCategory
    //           .generalHighwayDirectControl,
    //       "一般国道（その他）":
    //         sideMenuState.generalTraffic.time.roadCategory.generalHighwayOthers,
    //       都市高速道路:
    //         sideMenuState.generalTraffic.time.roadCategory.urbanHighway,
    //       高速自動車国道:
    //         sideMenuState.generalTraffic.time.roadCategory
    //           .expressNationalHighway,
    //     },
    //   },
    // },
    "ETC2.0": sideMenuState.etc.value,
    ETC情報: {
      データ種別: sideMenuState.etc.dataType,
      時間種別: sideMenuState.etc.timeType,
      道路種別: {
        高速自動車国道: sideMenuState.etc.expressNationalHighway,
        都市高速道路: sideMenuState.etc.urbanHighway,
        一般国道: sideMenuState.etc.generalHighway,
        "主要地方道（都道府県道）": sideMenuState.etc.mainLocalRoadPrefectures,
        "主要地方道（指定市市道）":
          sideMenuState.etc.mainLocalRoadDesinatedCity,
        一般都道府県道: sideMenuState.etc.generalPrefectures,
        特定市の一般市道: sideMenuState.etc.generalDesinatedCity,
      },
      平休日: sideMenuState.etc.dayType,
    },
    OD: sideMenuState.od.value,
    OD情報: {
      OD交通量: sideMenuState.od.od.value,
      OD交通量データ: {
        データ種別: sideMenuState.od.od.dataType,
        車種: sideMenuState.od.od.carType,
        年度: sideMenuState.od.od.year,
        制限: {
          上限値: sideMenuState.od.od.limitMax,
          下限値: sideMenuState.od.od.limitMin,
        },
      },
      "発生・集中交通量": sideMenuState.od.generation.value,
      "発生・集中交通量データ": {
        データ種別: sideMenuState.od.generation.dataType,
        車種: sideMenuState.od.generation.carType,
        年度: sideMenuState.od.generation.year,
        表示対象: sideMenuState.od.generation.target,
      },
      ゾーン位置表示: sideMenuState.od.zone.value,
      ゾーン位置表示データ: {
        データ種別: sideMenuState.od.zone.dataType,
        年度: sideMenuState.od.zone.year,
      },
    },
    DRM: sideMenuState.drm.value,
    DRMデータ: {
      道路区分: sideMenuState.drm.roadType,
      "ノード/リンク": {
        ノード: sideMenuState.drm.node,
        リンク: sideMenuState.drm.link,
      },
    },
    点検DB: sideMenuState.roadStructures.value,
    点検DBの情報: {
      施設区分: {
        道路橋: sideMenuState.roadStructures.facilityType.bridges,
        トンネル: sideMenuState.roadStructures.facilityType.tunnels,
        シェッド: sideMenuState.roadStructures.facilityType.sheds,
        大型カルバート: sideMenuState.roadStructures.facilityType.culverts,
        横断歩道橋: sideMenuState.roadStructures.facilityType.pedestrianDecks,
        門型標識等: sideMenuState.roadStructures.facilityType.overheadSignages,
        舗装: sideMenuState.roadStructures.facilityType.pavements,
        特定道路土工構造物:
          sideMenuState.roadStructures.facilityType.earthworks,
      },
      管理者区分: {
        国: sideMenuState.roadStructures.adminType.country.checked,
        都道府県: sideMenuState.roadStructures.adminType.prefectures.checked,
        道路公社: sideMenuState.roadStructures.adminType.roadPublic.checked,
        政令市: sideMenuState.roadStructures.adminType.orderedCity.checked,
        市区町村: sideMenuState.roadStructures.adminType.municipalities.checked,
        高速道路会社: sideMenuState.roadStructures.adminType.expressway.checked,
      },
      健全性: {
        I: sideMenuState.roadStructures.soundness.one.checked,
        Ⅱ: sideMenuState.roadStructures.soundness.two.checked,
        Ⅲ: sideMenuState.roadStructures.soundness.three.checked,
        Ⅳ: sideMenuState.roadStructures.soundness.four.checked,
        未点検: sideMenuState.roadStructures.soundness.notInspected.checked,
      },
      措置状況: {
        措置不要: sideMenuState.roadStructures.measures.unnecessary.checked,
        措置未着手: sideMenuState.roadStructures.measures.notStarted.checked,
        措置着手済: sideMenuState.roadStructures.measures.started.checked,
        措置完了済: sideMenuState.roadStructures.measures.completed.checked,
        未点検: sideMenuState.roadStructures.measures.notInspected.checked,
      },
    },
    交通事故統計情報: sideMenuState.accidentHotspot.value,
    交通事故統計情報の情報: {
      年度: accidentHotspotYear,
      事故内容: {
        死亡: sideMenuState.accidentHotspot.accidentDetails.death.checked,
        負傷: sideMenuState.accidentHotspot.accidentDetails.injury.checked,
      },
      事故類型: {
        人対車両:
          sideMenuState.accidentHotspot.accidentType.peopleVehicles.checked,
        車両相互:
          sideMenuState.accidentHotspot.accidentType.vehicleMutual.checked,
        車両単独:
          sideMenuState.accidentHotspot.accidentType.vehicleAlone.checked,
        列車: sideMenuState.accidentHotspot.accidentType.train.checked,
      },
      "当事者種別（当事者A）": {
        歩行者: sideMenuState.accidentHotspot.partyTypeA.pedestrian.checked,
        自転車: sideMenuState.accidentHotspot.partyTypeA.bicycle.checked,
        二輪車: sideMenuState.accidentHotspot.partyTypeA.motorcycle.checked,
        自動車: sideMenuState.accidentHotspot.partyTypeA.car.checked,
        その他: sideMenuState.accidentHotspot.partyTypeA.others.checked,
      },
      "当事者種別（当事者B）": {
        歩行者: sideMenuState.accidentHotspot.partyTypeB.pedestrian.checked,
        自転車: sideMenuState.accidentHotspot.partyTypeB.bicycle.checked,
        二輪車: sideMenuState.accidentHotspot.partyTypeB.motorcycle.checked,
        自動車: sideMenuState.accidentHotspot.partyTypeB.car.checked,
        その他: sideMenuState.accidentHotspot.partyTypeB.others.checked,
      },
      "年代別（当事者A）": {
        "0～24歳": sideMenuState.accidentHotspot.ageA.from0To24.checked,
        "25～64歳": sideMenuState.accidentHotspot.ageA.from25To64.checked,
        "65歳～": sideMenuState.accidentHotspot.ageA.over65.checked,
        不明: sideMenuState.accidentHotspot.ageA.unknown.checked,
      },
      "年代別（当事者B）": {
        "0～24歳": sideMenuState.accidentHotspot.ageB.from0To24.checked,
        "25～64歳": sideMenuState.accidentHotspot.ageB.from25To64.checked,
        "65歳～": sideMenuState.accidentHotspot.ageB.over65.checked,
        不明: sideMenuState.accidentHotspot.ageB.unknown.checked,
      },
    },
    ロードキル: sideMenuState.roadkill.value,
    ロードキルの情報: {
      ロードキル発生状況: sideMenuState.roadkill.occurrences.value,
      ロードキル発生状況の情報: {
        動物種: {
          タヌキ: sideMenuState.roadkill.occurrences.animal.racoonDog.checked,
          "犬・猫": sideMenuState.roadkill.occurrences.animal.dogAndCat.checked,
          鳥類: sideMenuState.roadkill.occurrences.animal.bird.checked,
          鳥類の情報: {
            希少種以外:
              sideMenuState.roadkill.occurrences.animal.bird.notRare.checked,
            "ウズラ（希少種）":
              sideMenuState.roadkill.occurrences.animal.bird.quail.checked,
            "オオワシ（希少種）":
              sideMenuState.roadkill.occurrences.animal.bird.stellersSeaEagle
                .checked,
            "オジロワシ（希少種）":
              sideMenuState.roadkill.occurrences.animal.bird.whiteTailedEagle
                .checked,
            "タンチョウ（希少種）":
              sideMenuState.roadkill.occurrences.animal.bird.redCrownedCrane
                .checked,
            "ハヤブサ（希少種）":
              sideMenuState.roadkill.occurrences.animal.bird.peregrineFalcon
                .checked,
            "ヤンバルクイナ（希少種）":
              sideMenuState.roadkill.occurrences.animal.bird.okinawaRail
                .checked,
          },
          シカ: sideMenuState.roadkill.occurrences.animal.deer.checked,
          シカの情報: {
            希少種以外:
              sideMenuState.roadkill.occurrences.animal.deer.notRare.checked,
            "ニホンカモシカ（希少種）":
              sideMenuState.roadkill.occurrences.animal.deer.japaneseSerow
                .checked,
          },
          キツネ: sideMenuState.roadkill.occurrences.animal.fox.checked,
          イノシシ: sideMenuState.roadkill.occurrences.animal.wildBoar.checked,
          その他: sideMenuState.roadkill.occurrences.animal.others.checked,
          その他の情報: {
            希少種以外:
              sideMenuState.roadkill.occurrences.animal.others.notRare.checked,
            "ケナガネズミ（希少種）":
              sideMenuState.roadkill.occurrences.animal.others.ryukyuRat
                .checked,
          },
        },
        発生年: roadKillYear,
        ヒートマップ: sideMenuState.roadkill.occurrences.heatmap,
      },
      対策実施状況: sideMenuState.roadkill.countermeasure.value,
      対策実施状況の情報: {
        対策分類: {
          警戒標識:
            sideMenuState.roadkill.countermeasure.classification.warningSign
              .checked,
          路面標示:
            sideMenuState.roadkill.countermeasure.classification.roadMarking
              .checked,
          道路横断施設:
            sideMenuState.roadkill.countermeasure.classification.underpass
              .checked,
          注意看板:
            sideMenuState.roadkill.countermeasure.classification.signboard
              .checked,
          "柵・フェンス":
            sideMenuState.roadkill.countermeasure.classification.fence.checked,
          道路情報板:
            sideMenuState.roadkill.countermeasure.classification
              .informationBoard.checked,
          移動式注意喚起看板:
            sideMenuState.roadkill.countermeasure.classification.portableSign
              .checked,
          その他:
            sideMenuState.roadkill.countermeasure.classification.others.checked,
        },
      },
    },
    "道路の指定・特定状況": sideMenuState.specificSituation.value,
    "道路の指定・特定状況の情報": {
      主要渋滞箇所: sideMenuState.specificSituation.trafficCongestion.value,
      重要物流道路: sideMenuState.specificSituation.importantLogistics.value,
      重要物流道路の情報: {
        太線表示: sideMenuState.specificSituation.importantLogistics.bold,
        データ種別: {
          全国重要物流道路:
            sideMenuState.specificSituation.importantLogistics.dataType
              .logistics,
          全国代替補完路:
            sideMenuState.specificSituation.importantLogistics.dataType
              .alternative,
        },
      },
      特殊車両データ: sideMenuState.specificSituation.specialVehicle.value,
      特殊車両データの情報: {
        太線表示: sideMenuState.specificSituation.specialVehicle.bold,
        データ種別: {
          "重さ・高さ指定道路":
            sideMenuState.specificSituation.specialVehicle.dataType
              .weightHeightDesignated,
          特車通行許可不要区間:
            sideMenuState.specificSituation.specialVehicle.dataType.exampt,
          大型車誘導区間:
            sideMenuState.specificSituation.specialVehicle.dataType
              .vehicleGuidance,
          "特車通行許可不要区間(交差点)":
            sideMenuState.specificSituation.specialVehicle.dataType
              .examptXPoint,
        },
      },
    },
    日時コントローラ: {
      地図属性: {
        年: executeMapTime.year,
        月: executeMapTime.month,
        日: executeMapTime.day,
        時: executeMapTime.hour,
        分: executeMapTime.minute,
      },
      属性: {
        年: executeAttributeTime.year,
        月: executeAttributeTime.month,
        日: executeAttributeTime.day,
        時: executeAttributeTime.hour,
        分: executeAttributeTime.minute,
      },
    },
    背景地図コントローラ: {
      背景地図: backgroundMap,
    },
  };
  return JSON.stringify(jsonData, null, 2);
};

/**
 * 設定読み込みファイル選択時チェック処理
 */
export const checkImportOptionFile = (data: any): boolean => {
  if (
    data.地図情報.緯度 === undefined ||
    data.地図情報.経度 === undefined ||
    data.地図情報.Zoomレベル === undefined ||
    data.日時コントローラ.地図属性.年 === undefined ||
    data.日時コントローラ.地図属性.月 === undefined ||
    data.日時コントローラ.地図属性.日 === undefined ||
    data.日時コントローラ.地図属性.時 === undefined ||
    data.日時コントローラ.地図属性.分 === undefined ||
    data.日時コントローラ.属性.年 === undefined ||
    data.日時コントローラ.属性.月 === undefined ||
    data.日時コントローラ.属性.日 === undefined ||
    data.日時コントローラ.属性.時 === undefined ||
    data.日時コントローラ.属性.分 === undefined ||
    data.背景地図コントローラ.背景地図 === undefined ||
    !new RegExp(/^\d{1,2}(\.\d{1,6})+$/).test(data.地図情報.緯度) ||
    !new RegExp(/^\d{1,3}(\.\d{1,6})+$/).test(data.地図情報.経度) ||
    data.地図情報.Zoomレベル < 5 ||
    data.地図情報.Zoomレベル > 18 ||
    !new RegExp(/^\d{0,4}$/).test(data.日時コントローラ.地図属性.年) ||
    !new RegExp(/^\d{0,2}$/).test(data.日時コントローラ.地図属性.月) ||
    !new RegExp(/^\d{0,2}$/).test(data.日時コントローラ.地図属性.日) ||
    !new RegExp(/^\d{0,2}$/).test(data.日時コントローラ.地図属性.時) ||
    !new RegExp(/^\d{0,2}$/).test(data.日時コントローラ.地図属性.分) ||
    !new RegExp(/^\d{0,4}$/).test(data.日時コントローラ.属性.年) ||
    !new RegExp(/^\d{0,2}$/).test(data.日時コントローラ.属性.月) ||
    !new RegExp(/^\d{0,2}$/).test(data.日時コントローラ.属性.日) ||
    !new RegExp(/^\d{0,2}$/).test(data.日時コントローラ.属性.時) ||
    !new RegExp(/^\d{0,2}$/).test(data.日時コントローラ.属性.分) ||
    ![1, 2, 3, 4].includes(data.背景地図コントローラ.背景地図)
  ) {
    return true;
  }
  if (
    data.Travos === undefined ||
    data.Travosデータ.過去最新 === undefined ||
    data.Travosデータ.過去データ.データ種別 === undefined ||
    data.Travosデータ.過去データ.常時観測データ計測値[
      "常設トラカン（様式Q-8-2）"
    ] === undefined ||
    data.Travosデータ.過去データ.常時観測データ計測値[
      "CCTVトラカン（様式QA-8-2）"
    ] === undefined ||
    data.Travosデータ.過去データ.道路種別.一般国道 === undefined ||
    data.Travosデータ.過去データ.道路種別.高速道路 === undefined ||
    data.Travosデータ.最新データ.データ種別 === undefined ||
    data.Travosデータ.最新データ["5分値"]["常設トラカン様式（Q-8-1）"] ===
      undefined ||
    data.Travosデータ.最新データ["5分値"]["CCTVトラカン（様式QA-8-1）"] ===
      undefined ||
    data.Travosデータ.最新データ["1時間値"]["常設トラカン様式（Q-8-2）"] ===
      undefined ||
    data.Travosデータ.最新データ["1時間値"]["CCTVトラカン（様式QA-8-2）"] ===
      undefined ||
    data.Travosデータ.最新データ.道路種別.一般国道 === undefined ||
    data.Travosデータ.最新データ.道路種別.高速道路 === undefined ||
    !Object.values(RADIO_TRAVOS_LIST).includes(data.Travosデータ.過去最新) ||
    !Object.values(RADIO_TRAVOS_HISTORY_LIST).includes(
      data.Travosデータ.過去データ.データ種別
    ) ||
    !Object.values(RADIO_TRAVOS_REALTIME_LIST).includes(
      data.Travosデータ.最新データ.データ種別
    ) ||
    typeof data.Travos !== "boolean" ||
    typeof data.Travosデータ.過去データ.常時観測データ計測値[
      "常設トラカン（様式Q-8-2）"
    ] !== "boolean" ||
    typeof data.Travosデータ.過去データ.常時観測データ計測値[
      "CCTVトラカン（様式QA-8-2）"
    ] !== "boolean" ||
    typeof data.Travosデータ.過去データ.道路種別.一般国道 !== "boolean" ||
    typeof data.Travosデータ.過去データ.道路種別.高速道路 !== "boolean" ||
    typeof data.Travosデータ.最新データ["5分値"][
      "常設トラカン様式（Q-8-1）"
    ] !== "boolean" ||
    typeof data.Travosデータ.最新データ["5分値"][
      "CCTVトラカン（様式QA-8-1）"
    ] !== "boolean" ||
    typeof data.Travosデータ.最新データ["1時間値"][
      "常設トラカン様式（Q-8-2）"
    ] !== "boolean" ||
    typeof data.Travosデータ.最新データ["1時間値"][
      "CCTVトラカン（様式QA-8-2）"
    ] !== "boolean" ||
    typeof data.Travosデータ.最新データ.道路種別.一般国道 !== "boolean" ||
    typeof data.Travosデータ.最新データ.道路種別.高速道路 !== "boolean"
  ) {
    return true;
  }
  if (
    data["ETC2.0"] === undefined ||
    data.ETC情報.データ種別 === undefined ||
    data.ETC情報.時間種別 === undefined ||
    data.ETC情報.道路種別.高速自動車国道 === undefined ||
    data.ETC情報.道路種別.都市高速道路 === undefined ||
    data.ETC情報.道路種別.一般国道 === undefined ||
    data.ETC情報.道路種別["主要地方道（都道府県道）"] === undefined ||
    data.ETC情報.道路種別["主要地方道（指定市市道）"] === undefined ||
    data.ETC情報.道路種別.一般都道府県道 === undefined ||
    data.ETC情報.道路種別.特定市の一般市道 === undefined ||
    data.ETC情報.平休日 === undefined ||
    !Object.values(RADIO_ETC_DATA_TYPE_LIST).includes(
      data.ETC情報.データ種別
    ) ||
    !Object.values(RADIO_ETC_TIME_TYPE_LIST).includes(data.ETC情報.時間種別) ||
    !Object.values(RADIO_ETC_DAY_TYPE_LIST).includes(data.ETC情報.平休日) ||
    typeof data["ETC2.0"] !== "boolean" ||
    typeof data.ETC情報.道路種別.高速自動車国道 !== "boolean" ||
    typeof data.ETC情報.道路種別.都市高速道路 !== "boolean" ||
    typeof data.ETC情報.道路種別.一般国道 !== "boolean" ||
    typeof data.ETC情報.道路種別["主要地方道（都道府県道）"] !== "boolean" ||
    typeof data.ETC情報.道路種別["主要地方道（指定市市道）"] !== "boolean" ||
    typeof data.ETC情報.道路種別.一般都道府県道 !== "boolean" ||
    typeof data.ETC情報.道路種別.特定市の一般市道 !== "boolean"
  ) {
    return true;
  }
  if (
    data.OD === undefined ||
    data.OD情報.OD交通量 === undefined ||
    data.OD情報.OD交通量データ.データ種別 === undefined ||
    data.OD情報.OD交通量データ.車種 === undefined ||
    data.OD情報.OD交通量データ.年度 === undefined ||
    data.OD情報.OD交通量データ.制限.上限値 === undefined ||
    data.OD情報.OD交通量データ.制限.下限値 === undefined ||
    data.OD情報["発生・集中交通量"] === undefined ||
    data.OD情報["発生・集中交通量データ"].データ種別 === undefined ||
    data.OD情報["発生・集中交通量データ"].車種 === undefined ||
    data.OD情報["発生・集中交通量データ"].年度 === undefined ||
    data.OD情報["発生・集中交通量データ"].表示対象 === undefined ||
    data.OD情報.ゾーン位置表示 === undefined ||
    data.OD情報.ゾーン位置表示データ.データ種別 === undefined ||
    data.OD情報.ゾーン位置表示データ.年度 === undefined ||
    !Object.values(OD_DATA_TYPE_LIST).includes(
      data.OD情報.OD交通量データ.データ種別
    ) ||
    !Object.values(OD_CAR_TYPE_LIST).includes(
      data.OD情報.OD交通量データ.車種
    ) ||
    !Object.values(OD_YEAR_LIST).includes(data.OD情報.OD交通量データ.年度) ||
    !new RegExp(/^\d{0,9}$/).test(data.OD情報.OD交通量データ.制限.上限値) ||
    !new RegExp(/^\d{0,9}$/).test(data.OD情報.OD交通量データ.制限.下限値) ||
    !Object.values(OD_DATA_TYPE_LIST).includes(
      data.OD情報["発生・集中交通量データ"].データ種別
    ) ||
    !Object.values(OD_CAR_TYPE_LIST).includes(
      data.OD情報["発生・集中交通量データ"].車種
    ) ||
    !Object.values(OD_YEAR_LIST).includes(
      data.OD情報["発生・集中交通量データ"].年度
    ) ||
    Number(data.OD情報["発生・集中交通量データ"].時間帯指定) < 0 ||
    Number(data.OD情報["発生・集中交通量データ"].時間帯指定) > 23 ||
    !Object.values(OD_TARGET_LIST).includes(
      data.OD情報["発生・集中交通量データ"].表示対象
    ) ||
    !Object.values(OD_DATA_TYPE_LIST).includes(
      data.OD情報.ゾーン位置表示データ.データ種別
    ) ||
    !Object.values(OD_YEAR_LIST).includes(
      data.OD情報.ゾーン位置表示データ.年度
    ) ||
    typeof data.OD !== "boolean" ||
    typeof data.OD情報.OD交通量 !== "boolean" ||
    typeof data.OD情報["発生・集中交通量"] !== "boolean" ||
    typeof data.OD情報.ゾーン位置表示 !== "boolean"
  ) {
    return true;
  }
  if (
    data.DRM === undefined ||
    data.DRMデータ.道路区分 === undefined ||
    data.DRMデータ["ノード/リンク"].ノード === undefined ||
    data.DRMデータ["ノード/リンク"].リンク === undefined ||
    !Object.values(RADIO_DRM_ROAD_TYPE_LIST).includes(
      data.DRMデータ.道路区分
    ) ||
    typeof data.DRM !== "boolean" ||
    typeof data.DRMデータ["ノード/リンク"].ノード !== "boolean" ||
    typeof data.DRMデータ["ノード/リンク"].リンク !== "boolean"
  ) {
    return true;
  }
  if (
    data.点検DB === undefined ||
    data.点検DBの情報.施設区分.道路橋 === undefined ||
    data.点検DBの情報.施設区分.トンネル === undefined ||
    data.点検DBの情報.施設区分.シェッド === undefined ||
    data.点検DBの情報.施設区分.大型カルバート === undefined ||
    data.点検DBの情報.施設区分.横断歩道橋 === undefined ||
    data.点検DBの情報.施設区分.門型標識等 === undefined ||
    data.点検DBの情報.施設区分.舗装 === undefined ||
    data.点検DBの情報.施設区分.特定道路土工構造物 === undefined ||
    data.点検DBの情報.管理者区分.国 === undefined ||
    data.点検DBの情報.管理者区分.都道府県 === undefined ||
    data.点検DBの情報.管理者区分.道路公社 === undefined ||
    data.点検DBの情報.管理者区分.政令市 === undefined ||
    data.点検DBの情報.管理者区分.市区町村 === undefined ||
    data.点検DBの情報.管理者区分.高速道路会社 === undefined ||
    data.点検DBの情報.健全性.I === undefined ||
    data.点検DBの情報.健全性.Ⅱ === undefined ||
    data.点検DBの情報.健全性.Ⅲ === undefined ||
    data.点検DBの情報.健全性.Ⅳ === undefined ||
    data.点検DBの情報.健全性.未点検 === undefined ||
    data.点検DBの情報.措置状況.措置不要 === undefined ||
    data.点検DBの情報.措置状況.措置未着手 === undefined ||
    data.点検DBの情報.措置状況.措置着手済 === undefined ||
    data.点検DBの情報.措置状況.措置完了済 === undefined ||
    data.点検DBの情報.措置状況.未点検 === undefined ||
    typeof data.点検DB !== "boolean" ||
    typeof data.点検DBの情報.施設区分.道路橋 !== "boolean" ||
    typeof data.点検DBの情報.施設区分.トンネル !== "boolean" ||
    typeof data.点検DBの情報.施設区分.シェッド !== "boolean" ||
    typeof data.点検DBの情報.施設区分.大型カルバート !== "boolean" ||
    typeof data.点検DBの情報.施設区分.横断歩道橋 !== "boolean" ||
    typeof data.点検DBの情報.施設区分.門型標識等 !== "boolean" ||
    typeof data.点検DBの情報.施設区分.舗装 !== "boolean" ||
    typeof data.点検DBの情報.施設区分.特定道路土工構造物 !== "boolean" ||
    typeof data.点検DBの情報.管理者区分.国 !== "boolean" ||
    typeof data.点検DBの情報.管理者区分.都道府県 !== "boolean" ||
    typeof data.点検DBの情報.管理者区分.道路公社 !== "boolean" ||
    typeof data.点検DBの情報.管理者区分.政令市 !== "boolean" ||
    typeof data.点検DBの情報.管理者区分.市区町村 !== "boolean" ||
    typeof data.点検DBの情報.管理者区分.高速道路会社 !== "boolean" ||
    typeof data.点検DBの情報.健全性.I !== "boolean" ||
    typeof data.点検DBの情報.健全性.Ⅱ !== "boolean" ||
    typeof data.点検DBの情報.健全性.Ⅲ !== "boolean" ||
    typeof data.点検DBの情報.健全性.Ⅳ !== "boolean" ||
    typeof data.点検DBの情報.健全性.未点検 !== "boolean" ||
    typeof data.点検DBの情報.措置状況.措置不要 !== "boolean" ||
    typeof data.点検DBの情報.措置状況.措置未着手 !== "boolean" ||
    typeof data.点検DBの情報.措置状況.措置着手済 !== "boolean" ||
    typeof data.点検DBの情報.措置状況.措置完了済 !== "boolean" ||
    typeof data.点検DBの情報.措置状況.未点検 !== "boolean"
  ) {
    return true;
  }
  if (
    data.一般交通量調査データの情報 &&
    (!isBoolean(data.一般交通量調査データ) ||
      !isEnumValue(
        RADIO_GENERAL_TRAFFIC_TABLE_TYPE_LIST,
        data.一般交通量調査データの情報.種別
      ) ||
      !isEnumValue(
        GENERAL_TRAFFIC_LOCTAION_DATA_TYPE_LIST,
        data.一般交通量調査データの情報.箇所別基本表.データ種別
      ) ||
      !isBoolean(
        data.一般交通量調査データの情報.箇所別基本表.道路種別[
          "一般都道府県道・指定市の一般市道"
        ]
      ) ||
      !isBoolean(
        data.一般交通量調査データの情報.箇所別基本表.道路種別[
          "主要地方道（都道府県道・指定市道）"
        ]
      ) ||
      !isBoolean(
        data.一般交通量調査データの情報.箇所別基本表.道路種別[
          "一般国道（直轄）"
        ]
      ) ||
      !isBoolean(
        data.一般交通量調査データの情報.箇所別基本表.道路種別[
          "一般国道（その他）"
        ]
      ) ||
      !isBoolean(
        data.一般交通量調査データの情報.箇所別基本表.道路種別.都市高速道路
      ) ||
      !isBoolean(
        data.一般交通量調査データの情報.箇所別基本表.道路種別.高速自動車国道
      ) ||
      data.一般交通量調査データの情報.時間帯別交通量表.時間帯 === undefined ||
      typeof data.一般交通量調査データの情報.時間帯別交通量表.時間帯 !==
        "string" ||
      !isBoolean(
        data.一般交通量調査データの情報.時間帯別交通量表.道路種別[
          "一般都道府県道・指定市の一般市道"
        ]
      ) ||
      !isBoolean(
        data.一般交通量調査データの情報.時間帯別交通量表.道路種別[
          "主要地方道（都道府県道・指定市道）"
        ]
      ) ||
      !isBoolean(
        data.一般交通量調査データの情報.時間帯別交通量表.道路種別[
          "一般国道（直轄）"
        ]
      ) ||
      !isBoolean(
        data.一般交通量調査データの情報.時間帯別交通量表.道路種別[
          "一般国道（その他）"
        ]
      ) ||
      !isBoolean(
        data.一般交通量調査データの情報.時間帯別交通量表.道路種別.都市高速道路
      ) ||
      !isBoolean(
        data.一般交通量調査データの情報.時間帯別交通量表.道路種別.高速自動車国道
      ))
  ) {
    return true;
  }
  return false;
};
